import { PageId } from 'constants/pages'
import { getPageById } from 'nove8/helpers/getPageById'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PAW_NUP: TStep[] = [
  {
    pageId: PageId.WELCOME_PAW_NUP,
  },
  {
    pageId: PageId.HOW_IT_WORKS_PAW_NUP,
  },
  {
    pageId: PageId.INTRODUCTION_PAW_NUP,
  },
  {
    pageId: PageId.MORNING_WALK_PAW_NUP,
  },
  {
    pageId: PageId.EVENING_WALK_PAW_NUP,
  },
  {
    pageId: PageId.FEEDING_PAW_NUP,
  },
  {
    pageId: PageId.VET_CARE_PAW_NUP,
  },
  {
    pageId: PageId.TRAINING_PAW_NUP,
  },
  {
    pageId: PageId.DISCIPLINE_PAW_NUP,
  },
  {
    pageId: PageId.CLEANUP_PAW_NUP,
  },
  {
    pageId: PageId.TREATS_PAW_NUP,
  },
  {
    pageId: PageId.KISSES_PAW_NUP,
  },
  {
    pageId: PageId.GROOMING_PAW_NUP,
  },
  {
    pageId: PageId.NIGHT_DUTY_PAW_NUP,
  },
  {
    pageId: PageId.RULES_PAW_NUP,
  },
  {
    pageId: PageId.ALLOWED_ON_BED_PAW_NUP,
  },
  {
    pageId: PageId.TABLE_SCRAPS_PAW_NUP,
  },
  {
    pageId: PageId.WHINES_PAW_NUP,
  },
  {
    pageId: PageId.COMMANDS_PAW_NUP,
  },
  {
    pageId: PageId.LISTEN_TO_PAW_NUP,
  },
  {
    pageId: PageId.CREATING_AGREEMENT_PAW_NUP,
  },
  {
    pageId: PageId.CONFLICT_PROOF_PAW_NUP,
  },
  {
    pageId: PageId.EMAIL_PAW_NUP,
  },
  {
    pageId: PageId.AGREEMENT_PAW_NUP,
  },
  {
    pageId: PageId.DOWNLOAD_PAW_NUP,
  },
]

export const ALL_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PAW_NUP.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar,
)
  .filter(({ pageId }) => !getPageById(pageId)?.progressBarHidden)
  .map(({ pageId }) => pageId)

export const CONTROLLED_PAGES_WITH_PROGRESS_BAR_IDS = STEPS_WOOFZ_PAW_NUP.filter(
  ({ pageId }) => getPageById(pageId)?.progressBar === 'controlled',
).map(({ pageId }) => pageId)
